<div class="ui-spinner-container" *ngIf="showSpinner">
	<mat-spinner class="ui-spinner" [diameter]="40"></mat-spinner>
</div>